

export const ORGANIZATION_CLASS_NAME = 'OrganizationDomain';
export const ORGANIZATION_COLLECTION = 'organizations';



// WEBPACK FOOTER //
// ./src/js/organizations/domain/config.js